import { render, staticRenderFns } from "./Stock_import.vue?vue&type=template&id=0670cbc9&scoped=true"
import script from "./Stock_import.vue?vue&type=script&lang=js"
export * from "./Stock_import.vue?vue&type=script&lang=js"
import style0 from "./Stock_import.vue?vue&type=style&index=0&id=0670cbc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670cbc9",
  null
  
)

export default component.exports